import Badge from '@/storybook/components/Badge/Badge';
import { useTranslation } from 'react-i18next';
import styles from './DropdownPlaceholderWithBadge.module.css';

export type DropdownPlaceHolderWithBadgeProps = {
  label: string;
};

export default function DropdownPlaceholderWithBadge({ label }: DropdownPlaceHolderWithBadgeProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.placeholderContainer}>
      <span className={styles.label}>{label}</span>{' '}
      <Badge color="grey" variant="light" data-testid="placeHolderBadge" size="S">
        {t('components.multiLevelDropdown.emptyListBadge')}
      </Badge>
    </div>
  );
}
